import { render, staticRenderFns } from "./PosterHorizontal.vue?vue&type=template&id=2f8effc2"
import script from "./PosterHorizontal.vue?vue&type=script&lang=js"
export * from "./PosterHorizontal.vue?vue&type=script&lang=js"
import style0 from "./PosterHorizontal.vue?vue&type=style&index=0&id=2f8effc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports